
export const toUnwidowedText = (string) => {
  return ((string != null && string != undefined && string.length > 0 && string.lastIndexOf(' ') > string.lastIndexOf('‑')) ? string.replace(/\s([^\s<]+)\s*$/, '\u00A0$1') : string);
}


export const arrayToSentence = (array, andOr = "&") => {
  return array.length > 1 ? `${array.slice(0, -1).join(', ')} ${andOr} ${array.slice(-1)}` : array.length > 0 ? array[0] : ``;
}

export const truncate = (text, length = 30, ellipsis = '...') => {
  const words = text.split(" ");
  if (words.length > length) {
    return words.slice(0, length).join(" ") + ellipsis;
  } else {
    return text;
  }
}
